module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAACZZ43PAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEISURBVHgB1VO9DoIwGGxLByf+JsdKIHET30A3R99ARzdX304346S+AY+AmwM/3kfUILZE2Lykafl6ve9orhZrQRRFsW3bgxQwcYRpIwiCdZ7nZyHEWSnlmnhWs0Bk3/d3ZVmuOOdDlAYYC9d17zBybfJ543CMjnsstR0hmmDME+BLAIcV2TUdbohMoVHdy/sO2jp/WOacGm0/HIRhOCuKYs9+Rwr+iFxUDvAxYd1AThUtRK3QFU5doDf+W6C6N/HM+Zp1BLKwpNlC7o+Yx6w7Ys/zbhKLA6KZ9hCoYs11G/RbUsq4Xsuy7PLKfx2SGexpou3piJauiHefOI5DD4dc3CG2QfeTjvsA/nJhJhtFdMkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaoxi.png
// module id = TqWt
// module chunks = 1